jQuery(document).ready(function ($) {
	const $slider = $(".header-slider");
	const $team_slider = $(".team-slider");

	function initSlider() {
		if ($slider.hasClass("slick-initialized")) return;

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			adaptiveHeight: true,
			infinite: true,

			// autoplay
			autoplay: true,
			autoplaySpeed: 4000,

			// smooth transition
			speed: 800,
			cssEase: "ease-in-out", 

			// UX polish
			pauseOnHover: false,
			pauseOnFocus: false,
			pauseOnDotsHover: true,
			swipeToSlide: true,
		});
	}

	function destroySlider() {
		if ($slider.hasClass("slick-initialized")) {
			$slider.slick("unslick");
		}
	}

	function checkMobile() {
		if (window.innerWidth <= 1300) {
			initSlider();
		} else {  
			destroySlider();
		}
	}

	checkMobile();
	$(window).on("resize", checkMobile);

	// // team-slider
	// function initTeamSlider() {
	// 	const $team = $team_slider;

	// 	// Only initialize if not already
	// 	if ($team.hasClass("slick-initialized")) return;

	// 	if (typeof $.fn.slick === "undefined") {
	// 		console.warn("Slick slider not loaded yet for team-slider");
	// 		return;
	// 	}

	// 	$team.slick({
	// 		slidesToShow: 2,
	// 		slidesToScroll: 2,
	// 		rows: 2,
	// 		arrows: false,
	// 		dots: true,
	// 		appendDots: $team.closest(".team-slider-block").find(".slide-m-dots"),
	// 		adaptiveHeight: true,
	// 		speed: 1000,
	// 		responsive: [
	// 			{
	// 				breakpoint: 768,
	// 				settings: {
	// 					slidesToShow: 1,
	// 					slidesToScroll: 1,
	// 					rows: 1,
	// 				},
	// 			},
	// 		],
	// 	});
	// } 

	// function destroyTeamSlider() {
	// 	if ($team_slider.hasClass("slick-initialized")) {
	// 		$team_slider.slick("unslick");
	// 	}
	// }

	// // Only initialize on all screen sizes (remove destroy if you want it always)
	// initTeamSlider(); 
});
